import { t } from '@lingui/macro';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import Loading from '@decisiv/ui-components/lib/components/Loading';

const StepTwo = () => (
  <Flex flex={1} flexDirection="column" alignItems="center" marginTop={1.5}>
    <Loading
      size="small"
      title={t`Validating VIN(s)...`}
      description={t`Your assets are being processed. Closing this window won't interrupt it. Results will be available when complete.`}
    />
  </Flex>
);

export default StepTwo;
